import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import Transaction from '@/ts/Transaction';

@Module({name: 'CorpTransactions', namespaced: true})
export default class CorpTransactions extends VuexModule {
    public unpaidTransactionsData: Transaction[] = [];

    get unpaidTransactionData() {
        return this.unpaidTransactionsData;
    }

    @Mutation
    public SET_CORPORATION_UNPAID_TRANSACTIONS_DATA(unpaidTransactionsData: any[]): void {
        this.unpaidTransactionsData = [];
        for (const unpaidPayment of unpaidTransactionsData) {
            this.unpaidTransactionsData.push(new Transaction(
                unpaidPayment.externalId,
                unpaidPayment.date,
                unpaidPayment.orderDate,
                unpaidPayment.orderType,
                unpaidPayment.orderId,
                unpaidPayment.orderAmount,
                unpaidPayment.unitId,
                unpaidPayment.unitTitle,
                unpaidPayment.unitAddress,
                unpaidPayment.additionalData,
                unpaidPayment.orderDescription,
                unpaidPayment.paymentMethod,
                unpaidPayment.paymentStatus,
                unpaidPayment.currency,
                unpaidPayment.tenantName,
                unpaidPayment.tenantId,
                unpaidPayment.project,
                unpaidPayment.paymentDate,
                unpaidPayment.totalAmount,
            ));
        }
    }

    @Action
    public FETCH_CORPORATION_TRANSACTIONS_DATA(): void {
        axios.get(Endpoints.Admin.Finances.FETCH_CORPORATION_TRANSACTIONS_DATA)
            .then((response: any) => {
                store.commit(Mutations.SET_CORPORATION_UNPAID_TRANSACTIONS_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

}
